import script from "./confirm-validation.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-validation.vue?vue&type=script&setup=true&lang=js"

import "./confirm-validation.vue?vue&type=style&index=0&id=5279ae34&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5279ae34"]])

export default __exports__